import React, { Component } from "react";
import "./Trash.css";
import SuccessSnackbar from "../../MaterialComponents/Snackbars/SnackbarSucces";
import Paper from "@material-ui/core/Paper";
import SwipeableList from "../SwipeableList/SwipeableList";
import SwipeableListItem from "../SwipeableListItem/SwipeableListItem";
import displayDate from "../../../Utilities/displayDate";
import orderList from "../../../Utilities/orderList";
import categorizeList from "../../../Utilities/categorizeList";
import { store } from "../../../Store/store";
import ListFunctions from "../ListFunctions/ListFunctions";

export default class Trash extends Component {
  componentDidMount() {
    let currentOrder = store.getState().firebase.listOrder;
    if (currentOrder !== "" && currentOrder !== undefined) {
      orderList(this.props.currentTrash, currentOrder, "trash");
    }
  }

  componentWillUnmount() {
    categorizeList("all", "trash");
  }

  render() {
    let content = [];
    const { currentTrash } = this.props;
    let filterValue = this.props.filter;

    this.addItemTolist = (key) => {
      let manualSymbol = null;
      let ean = currentTrash[key].EANcode.toString();
      if (ean.length === 10) {
        manualSymbol = (
          <img
            src={require("../../../Images/Icons/manualIcon.svg")}
            alt="manualIcon"
            style={{ marginLeft: "4px", width: "12px", height: "12px" }}
            className="manualIcon"
          ></img>
        );
      }

      var climateImg = null;
      if (currentTrash[key].carbon_fp !== undefined) {
        if (currentTrash[key].carbon_fp.climateScore !== undefined) {
          climateImg = (
            <img
              className="climateScore"
              src={require(`../../../Images/Icons/${
                "score" + currentTrash[key].carbon_fp.climateScore + ".svg"
              }`)}
              alt="climateScore"
            />
          );
        } else {
          climateImg = (
            <img
              className="climateScore"
              src={require("../../../Images/Icons/scoreNan.svg")}
              alt="climateScore"
            />
          );
        }
      } else {
        climateImg = (
          <img
            className="climateScore"
            src={require("../../../Images/Icons/scoreNan.svg")}
            alt="climateScore"
          />
        );
      }

      content.push(
        <SwipeableListItem
          key={currentTrash[key].EANcode}
          id={currentTrash[key].EANcode}
          expanded={false}
          onSwipe={(removeAll) =>
            this.props.onDelete(currentTrash[key], "trash", removeAll)
          }
          dates={currentTrash[key].deletionDates}
        >
          <div className="container col-5 listCell">
            {" "}
            {climateImg}
            {currentTrash[key].name}
            {manualSymbol}
          </div>
          <div className="container col-1 listCell">
            {currentTrash[key].quantity}
          </div>
          <div className="container col-2 listDate">
            {displayDate(currentTrash[key].deletionDates[0])}
          </div>
          <div className="container col-2 listCell d-none d-sm-block">
            {currentTrash[key].comment}
          </div>
          <div className="container col-2 listBtn">
            {" "}
            <SuccessSnackbar
              onAddTo={this.props.onAddTo}
              itemToAdd={currentTrash[key]}
              comesFrom="trash"
              actionStatus="move"
            />
          </div>
        </SwipeableListItem>
      );
    };
    if (currentTrash !== undefined || currentTrash.length !== 0) {
      for (let key in currentTrash) {
        if (filterValue === "" || filterValue === undefined) {
          try {
            this.addItemTolist(key);
          } catch (error) {
            console.log("Error in trash 1: ", error);
          }
        } else {
          try {
            if (currentTrash[key].name.toLowerCase().includes(filterValue)) {
              this.addItemTolist(key);
            }
          } catch (error) {
            console.log("Error in trash 2: ", error);
          }
        }
      }
    }

    return (
      <div className="row">
        <Paper
          className="container-fluid col-lg-10 col-md-10 col-sm-11 trashBody"
          elevation={6}
          square
        >
          <ListFunctions
            language={this.props.language}
            onSearch={this.props.onSearch}
            filter={this.props.filter}
            emptyFilter={this.props.emptyFilter}
          />
          <SwipeableList language={this.props.language}>
            {content}
          </SwipeableList>
        </Paper>
      </div>
    );
  }
}
